module.exports = __webpack_public_path__ + "1d9c7945c7bc7dd0909105119bfbc191.eot";


//////////////////
// WEBPACK FOOTER
// ./public/fonts/OpenSans-Bold-webfont.eot
// module id = 440
// module chunks = 0